// frontend/src/pages/admin/Reports.js
import React, { useState } from 'react';
import { 
  FiPackage,
  FiTrendingUp,
  FiShoppingCart,
  FiDollarSign,
  FiUsers
} from 'react-icons/fi';

// Report Components
import OrdersReport from './reports/OrdersReport';
import ProfitReport from './reports/ProfitReport';
import SalesReport from './reports/SalesReport';
import RevenueReport from './reports/RevenueReport';
import TopCustomers from './reports/TopCustomers';

const Reports = () => {
  const [activeTab, setActiveTab] = useState('orders');

  const tabs = [
    { id: 'orders', label: 'Захиалга', icon: FiPackage, color: 'blue' },
    { id: 'profit', label: 'Ашгийн тайлан', icon: FiTrendingUp, color: 'green' },
    { id: 'sales', label: 'Борлуулалт (POS)', icon: FiShoppingCart, color: 'purple' },
    { id: 'revenue', label: 'Орлого', icon: FiDollarSign, color: 'indigo' },
    { id: 'customers', label: 'Топ харилцагчид', icon: FiUsers, color: 'orange' }
  ];

  return (
    <div className="reports-page">
      {/* Page Header */}
      <div className="mb-6">
        <h1 className="text-2xl font-bold text-gray-900">📊 Тайлан</h1>
        <p className="text-gray-600 mt-1">
          Захиалга, ашиг, борлуулалт, орлого, харилцагчийн тайлангууд
        </p>
      </div>

      {/* Tabs */}
      <div className="card mb-6">
        <div className="flex space-x-1 overflow-x-auto">
          {tabs.map(tab => {
            const Icon = tab.icon;
            const isActive = activeTab === tab.id;
            
            return (
              <button
                key={tab.id}
                onClick={() => setActiveTab(tab.id)}
                className={`flex items-center px-6 py-3 font-semibold whitespace-nowrap transition-all ${
                  isActive
                    ? 'text-blue-600 border-b-2 border-blue-600 bg-blue-50'
                    : 'text-gray-600 hover:text-gray-900 hover:bg-gray-50'
                }`}
              >
                <Icon className="mr-2" size={18} />
                {tab.label}
              </button>
            );
          })}
        </div>
      </div>

      {/* Tab Content */}
      <div>
        {activeTab === 'orders' && <OrdersReport />}
        {activeTab === 'profit' && <ProfitReport />}
        {activeTab === 'sales' && <SalesReport />}
        {activeTab === 'revenue' && <RevenueReport />}
        {activeTab === 'customers' && <TopCustomers />}
      </div>
    </div>
  );
};

export default Reports;